import React from 'react';


const EscalationVolumeChart = ({ data, chartType = 'area' }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) =>
          <div key={index} className="flex items-center justify-between gap-4 text-xs">
              <span className="text-muted-foreground">{entry?.name}:</span>
              <span className="font-medium" style={{ color: entry?.color }}>{entry?.value}</span>
            </div>
          )}
        </div>);

    }
    return null;
  };

  return;














































































};

export default EscalationVolumeChart;